<template>
    <div @click="open" :class="{'reminder-item': true, 'waiting': reminder.status == STATUS_WAITING, 'done': reminder.status == STATUS_COMPLETED}">
        <div class="reminder-icon">
            <i class="icon icon-reminder-clock" v-if="reminder.status == STATUS_WAITING"></i>
            <i class="icon icon-reminder-ok" v-else></i>
        </div>
        <div class="reminder-info">
            <div class="reminder-header">
                <div class="reminder-title" v-text="reminder.title"></div>
                <div class="reminder-time" v-text="reminder.time"></div>
            </div>
            <div class="reminder-footer">
                <div class="reminder-category" v-if="reminder.category" v-text="reminder.category.name"></div>
                <div class="reminder-amount">
                    {{ reminder.amount | money }} {{ reminder.currency | currency }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReminderWidgetItem",

    props: ['reminder'],

    data: function() {
        return {
            STATUS_PLANNED: 0,
            STATUS_WAITING: 1,
            STATUS_COMPLETED: 2,
            STATUS_CANCELED: 3,
        };
    },

    methods: {
        open() {
            this.$emit('open', this.reminder);
        }
    }
}
</script>

<style scoped lang="scss">
.reminder-item {
    border-top: 1px solid rgba(#152640, .1);
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 10px 0 12px;

    .reminder-icon {
        .icon {
            width: 20px;
            height: 20px;
            background-color: rgba(#152640, .5);
        }

        margin-right: 8px;
    }

    &.waiting {
        .icon {
            background-color: #F1A84E;
        }
    }

    &.done {
        .icon {
            background-color: #76C89E;
        }
    }

    .reminder-info {
        width: 100%;

        .reminder-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            color: #152640;

            .reminder-title {
                font-family: 'Proxima Nova Lt';
                font-weight: 600;
                font-size: 14px;
            }

            .reminder-time {
                font-family: 'Proxima Nova Rg';
                font-size: 12px;
                color: rgba(#152640, .5);
            }

            margin-bottom: 8px;
        }

        .reminder-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            color: #152640;

            .reminder-category {
                font-family: 'Proxima Nova Rg';
                font-size: 12px;
                color: rgba(#152640, .5);
            }

            .reminder-amount {
                font-family: 'Proxima Nova Rg';
                font-size: 14px;
            }
        }
    }
}
</style>